import { Component, OnInit } from '@angular/core';
import { BlogDataService } from '@shared/service/blog-data.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  categories;
  links = [
    {
      url: 'https://web.facebook.com/%D7%91%D7%A2%D7%A7%D7%91%D7%95%D7%AA-%D7%94%D7%98%D7%91%D7%A2-%D7%92%D7%A9%D7%A9%D7%95%D7%AA-%D7%95%D7%9E%D7%95%D7%93%D7%A2%D7%95%D7%AA-%D7%91%D7%98%D7%91%D7%A2-Tracking-and-Nature-Awareness-852263394810249/',
      name: '	דף הפייסבוק של גששות בעקבות הטבע'
    },
    {
      url: 'https://www.makommifgash.org',
      name: '	מקום מפגש',
    },
    {
      url: 'https://www.cybertracker.org',
      name: 'ארגון סייבר טרקר העולמי',
    },
    {
      url: 'http://www.colinpatrick.co.za',
      name: 'קולין פטריק',
    },
    {
      url: 'https://www.bear-tracker.com',
      name: 'קים קרברה',
    },
    {
      url: 'http://www.naturetracking.com',
      name: `ג'ונה אוונס`,
    },
  ];
  constructor(
    public blogDataService: BlogDataService
  ) { }

  ngOnInit() {
    this.categories = this.blogDataService.allCategories;
  }

  setSelectedCategory(category: string) {
    this.blogDataService.setSelectedCategory(category);
  }

  externalRoute(url) {
    window.open(url, '_blank');
  }

}
